import { Notification } from "@cnx/common";
import { Box, Flex, Stack, Text } from "@mantine/core";
import NotificationTitle from "components/NotificationWidget/NotificationTitle";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

import { selectIconByNotificationType } from "utils/notifications";

interface NotificationCardProps {
  notification: Notification;
}

const NotificationCardPreview: React.FC<NotificationCardProps> = ({
  notification,
}) => {
  const { t } = useTranslation("notifications");

  const {
    title,
    notificationTypeKey,
    notificationTypeName,
    createdTime,
    trailerLicenceNumber,
  } = notification;
  const icon = selectIconByNotificationType({
    notificationType: notificationTypeKey,
    size: 30,
    iconSize: 15,
  });

  return (
    <Flex
      w={"100%"}
      className={"hover:bg-blue-highlight"}
      align={"center"}
      gap={"md"}
    >
      <Box>{icon}</Box>
      <Stack className={"flex-1"} gap={4}>
        <NotificationTitle
          notificationTypeName={notificationTypeName}
          title={title}
          trailerLicenceNumber={trailerLicenceNumber}
        />

        <Text c={"gray"} lh={1} fz={10}>
          {dayjs(createdTime).format(t("createdAtFormat"))}
        </Text>
      </Stack>
    </Flex>
  );
};

export default NotificationCardPreview;
